import * as React from 'react';
import {Avatar, theme} from 'antd';
import {observer} from 'mobx-react-lite';
import {appState} from 'store/AppStore';

export const PRMGAvatar: React.FC = observer(() => {
  const {token} = theme.useToken();

  return (
    <Avatar style={{color: token.blue, backgroundColor: token['blue-1'], fontWeight: token.fontWeightStrong}}>
      {appState.user?.displayName?.[0]}
    </Avatar>
  );
});
